import { assert_string_not_empty, wrong_case } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__database_entity } from '../_database_entity/DTO__database_entity';
import { DTO__grid2d_cell_generation } from '../grid2d_cell/DTO__grid2d_cell_generation';
import { DTO__grid2d_chunk_generic } from './DTO__grid2d_chunk_generic';

//grid2d generation contains unique list of cells by x+y
export class DTO__grid2d_chunk_generation extends DTO__grid2d_chunk_generic<DTO__grid2d_cell_generation> {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.GRID2D_CHUNK_GENERATION;

  /*
   * DB FIELDS
   */

  user_task_id!: string;

  cells_amount__x!: number;
  cells_amount__y!: number;

  /*
   * PROPERTIES
   */

  get images_to_generate_amount() {
    return this.cells_list.filter(cell => cell.hash_sha256_content.is_empty_hash_sha256()).length;
  }
  /*
   * METHODS
   */

  get_cell_by_coordinates(x: number, y: number): DTO__grid2d_cell_generation {
    let out = this.cells_list.find(cell => cell.x == x && cell.y == y);

    if (!out) out = DTO__grid2d_cell_generation.CREATE_STUB().clone({ x, y });

    return out;
  }

  create_stub_cell() {
    return DTO__grid2d_cell_generation.CREATE_STUB();
  }

  override upsert_cell(cell: DTO__grid2d_cell_generation) {
    let cell_index = this.cells_list.findIndex(item => item.x == cell.x && item.y == cell.y);

    if (cell_index == -1) {
      this.cells_list = [cell, ...this.cells_list];
    } else {
      this.cells_list[cell_index] = cell;
    }

    this.cells_list.sort(DTO__database_entity.sort_by_updated_at_newest_first);

    //recreate to rerender
    this.cells_list = [...this.cells_list];
  }

  override delete_cell(_: DTO__grid2d_cell) {
    wrong_case();
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.user_task_id);
  }
}
